import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const getConversionFunnelReport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETCONVERSIONFUNNELREPORT,
    params
  );
  return data;
};
const getTeamPerformanceReport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETTEAMPERFORMANCEREPORT,
    params
  );
  return data;
};
const getTeamCpPerformanceReport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETTEAMCPPERFORMANCEREPORT,
    params
  );
  return data;
};
const getReportPropertyList = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETREPORTPROPERTYLIST,
    params
  );
  return data;
};
const getReportEmployeeList = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETREPORTEMPLOYEELIST,
    params
  );
  return data;
};
const getMonthlyPropertyReport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.MONTHLYPORPERTYREPORT,
    params
  );
  return data;
};
const getUserActivityReport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.USERACTIVITYREPORT,
    params
  );
  return data;
};
const getPdrReport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETPDRREPORT,
    params
  );
  return data;
};

const getSTreport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETSTREPORT,
    params
  );
  return data;
};
const getCTreport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETCTREPORT,
    params
  );
  return data;
};
const getCMreport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETCMREPORT,
    params
  );
  return data;
};
const getSMreport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETSMREPORT,
    params
  );
  return data;
};
const getSHCHreport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETSHCHREPORT,
    params
  );
  return data;
};
const getSCMreport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETSCMREPORT,
    params
  );
  return data;
};
const getSrcHreport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETSRCHREPORT,
    params
  );
  return data;
};
const getBMreport = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.GETBMREPORT,
    params
  );
  return data;
};
const ReportService = {
  getConversionFunnelReport,
  getTeamPerformanceReport,
  getReportPropertyList,
  getReportEmployeeList,
  getTeamCpPerformanceReport,
  getMonthlyPropertyReport,
  getUserActivityReport,
  getPdrReport,
  getSTreport,
  getCTreport,
  getCMreport,
  getSMreport,
  getSHCHreport,
  getSrcHreport,
  getSCMreport,
  getBMreport,
};

export default ReportService;
